import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Logo from '../ui/Logo';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <footer className="py-12 bg-gray-900 text-gray-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Product */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t('landing.footer.product')}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/#features" className="hover:text-white transition">{t('landing.footer.features')}</a></li>
              <li><a href="/#pricing" className="hover:text-white transition">{t('landing.footer.pricing')}</a></li>
              <li><a href="/#how-it-works" className="hover:text-white transition">{t('landing.footer.howItWorks')}</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t('landing.footer.support')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/faq" className="hover:text-white transition">{t('landing.footer.faq')}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">{t('landing.footer.contact')}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t('landing.footer.legal')}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="hover:text-white transition">{t('landing.footer.termsOfService')}</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition">{t('landing.footer.privacyPolicy')}</Link></li>
              <li><Link to="/cookies" className="hover:text-white transition">{t('landing.footer.cookiePolicy')}</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t('landing.footer.connect')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:hello@instantexam.co" className="hover:text-white transition">
                  hello@instantexam.co
                </a>
              </li>
              <li>
                <a href="https://x.com/instantexam" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
                  {t('landing.footer.xTwitter')}
                </a>
              </li>
              <li>
                <a href="https://linkedin.com/company/infinitelabs" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
                  {t('landing.footer.linkedIn')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Logo variant="full" size="sm" className="[&_span.font-semibold]:text-gray-300 [&_span.font-extrabold]:text-white" />
          <div className="text-center sm:text-right text-sm">
            <p className="text-gray-500 text-xs mb-1">Built with ❤️ by a solo developer orchestrating AI agents</p>
            <p>
              {t('landing.footer.madeBy')}{' '}
              <a href="https://infinitelabs.co" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition">
                {t('landing.footer.companyName')}
              </a>
            </p>
            <p className="mt-1">{t('landing.footer.allRightsReserved', { year: new Date().getFullYear() })}</p>
          </div>
        </div>
        <div className="mt-6 pt-4 border-t border-gray-800 flex flex-wrap items-center justify-center gap-4 text-xs text-gray-500">
          <span className="font-semibold uppercase tracking-wider">Also by Infinite Labs:</span>
          <a href="https://contestia.co" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Contestia ↗</a>
          <a href="https://regulia.app" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Regulia ↗</a>
          <a href="https://swarmix.co" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Swarmix ↗</a>
          <a href="https://contablia.app" target="_blank" rel="noopener noreferrer" className="hover:text-white transition">Contablia ↗</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
